import { createRouter, createWebHistory } from 'vue-router'
import { usePtsSignUpStore } from '@/store/PtsSignupTest'
import { useMicrositeStore } from '@/store/Microsites'

const PTS = () => /* webpackChunkName: "ms-pts" */ import('@/views/pts/index.vue')

const routes = [
  {
    path: '/maplestory/public-test-server',
    component: PTS,
    beforeEnter: async (to, _from, next) => {
      const PtsSignUpStore = usePtsSignUpStore()
      const micrositeStore = useMicrositeStore()
      const hasSignupQuery = Boolean(to.query.ptssignup)

      micrositeStore.loading = true

      try {
        await PtsSignUpStore.fetchNewsList()

        if (PtsSignUpStore.isSignupOpen && PtsSignUpStore.isLoggedIn === null) {
          // Only show the login / eligibility dialogs when arriving via ?ptssignup
          await PtsSignUpStore.checkUserStatus(hasSignupQuery)
        }
      } catch {
        // Errors here must not block the page from rendering
      } finally {
        micrositeStore.loading = false
      }

      if (hasSignupQuery) {
        // Remove the query parameter from the URL
        const query = { ...to.query }
        delete query.ptssignup
        next({ ...to, query, replace: true })
        return
      }

      next()
    },
  },
  {
    name: 'news-detail',
    path: '/maplestory/public-test-server/news/:newsCategory?/:newsId(\\d+)/:seo?',
    component: () => /* webpackChunkName: "ms-pts" */ import('@/views/pts/NewsDetail.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    beforeEnter: (to) => {
      window.location.href = '/maplestory/error'
    },
    component: { template: '<div></div>' },
  },
]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

export { router, routes }
